<template>
  <BriefStep :title="title">
    <template v-slot:content>
      <div class="brief-form form">
        <div data-uk-accordion="content: > .description; toggle: > .link">
          <div
            class="brief-step__dynamic-content"
            v-for="(item, index) in $v.form.inspirationsSitesLinks.$each.$iter"
            :key="index"
          >
            <div
              class="form__input-wrapper link"
              :class="{ error: item.link.$anyError, disabled: form.inspirationsSitesSkip }"
            >
              <label :for="`is-link-${Number(index) + 1}`" class="form__label">
                link {{ Number(index) + 1 }} *
              </label>
              <div class="uk-position-relative">
                <input
                  class="form-input form-input--icon"
                  :id="`is-link-${Number(index) + 1}`"
                  type="text"
                  :name="`is-link-${Number(index) + 1}`"
                  v-model.trim="item.link.$model"
                  @input="delayTouch(item.link)"
                  @change="delayTouch(item.link)"
                  :disabled="form.inspirationsSitesSkip"
                />
                <button
                  class="icon"
                  :disabled="form.inspirationsSitesSkip"
                  @click="pasteText(Number(index), item.link)"
                >
                  <img
                    data-uk-svg
                    src="@/assets/images/paste.svg"
                    alt="wklej"
                  />
                </button>
                <button
                  class="icon icon--remove"
                  v-if="index > 0"
                  :disabled="form.inspirationsSitesSkip"
                  @click.prevent="removeLink(index)"
                >
                  <img
                    data-uk-svg
                    src="@/assets/images/rubbish.svg"
                    alt="usuń"
                  />
                </button>
              </div>
              <span class="form__error-message">
                <template v-if="!item.link.required">
                  {{ validationMessage.required }}</template
                >
              </span>
            </div>
            <div
              class="
                form__input-wrapper form__input-wrapper--textarea
                description
              "
              :class="{ error: item.description.$anyError }"
            >
              <label for="is-description-site" class="form__label"
                >co się podoba? *</label
              >
              <textarea
                class="form-input"
                name="is-description-site"
                id="is-description-site"
                @input="event => setDescription(item.description, event.target.value)"
                cols="30"
                :disabled="form.inspirationsSitesSkip"
              />
              <span class="form__error-message">
                <template v-if="!item.description.minLength">
                  {{ validationMessage.minLength }}</template
                >
                <template v-if="!item.description.required">
                  {{ validationMessage.required }}</template
                >
              </span>
            </div>
          </div>
        </div>
        <div class="brief-step__add-item-wrapper">
          <button
            class="brief-step__add-item form__label"
            @click="addLink"
            v-if="!maxLinks"
          >
            + dodaj link
          </button>
        </div>
        <div
          class="
            brief-step__skip-step
            form__input-wrapper
            form__input-wrapper--check
            form__input-wrapper--check-squer
          "
        >
          <input
            class=""
            id="inspirationsSitesSkip"
            type="checkbox"
            name="inspirationsSitesSkip"
            :value="form.inspirationsSitesSkip"
            v-model.trim="form.inspirationsSitesSkip"
            @change="delayTouch($v.form)"
          />
          <label for="inspirationsSitesSkip" class="form__label">
            Pominąć ten krok?
          </label>
        </div>
      </div>
    </template>
  </BriefStep>
</template>
<script>
import { minLength, required } from 'vuelidate/lib/validators';
import stepValidation from '../../mixins/stepValidation';

import BriefStep from '../global/BriefStep.vue';

export default {
  name: 'InspirationSites',
  components: { BriefStep },
  mixins: [stepValidation],
  data: () => ({
    title:
      'Dobra inspiracja nie jest zła! Podziel się linkami stron, które przypadły Ci do gustu.',
    form: {
      inspirationsSitesSkip: false,
      inspirationsSitesDescription: '',
      inspirationsSitesLinks: [
        {
          link: '',
          description: '',
        },
      ],
    },
  }),
  computed: {
    maxLinks() {
      return this.form.inspirationsSitesLinks.length === 10;
    },
  },
  validations() {
    if (this.form.inspirationsSitesSkip) {
      return {
        form: {
          inspirationsSitesLinks: {
            $each: {
              link: {},
              description: {},
            },
          },
        },
      };
    }
    return {
      form: {
        inspirationsSitesLinks: {
          required,
          minLength: minLength(1),
          $each: {
            link: {
              required,
            },
            description: {
              required,
              minLength: minLength(3),
            },
          },
        },
      },
    };
  },
  methods: {
    setDescription(item, value) {
      item.$model = value;
      this.delayTouch(item);
    },
    addLink() {
      if (this.form.inspirationsSitesSkip) return;
      this.form.inspirationsSitesLinks.push({ link: '', description: '' });
    },
    removeLink(index) {
      if (this.form.inspirationsSitesSkip) return;
      this.form.inspirationsSitesLinks.splice(index, 1);
    },
    async pasteText(index, item) {
      if (this.form.inspirationsSitesSkip) return;
      const textFromClipboard = await navigator.clipboard.readText();

      // eslint-disable-next-line operator-linebreak
      this.$v.form.inspirationsSitesLinks.$each.$iter[index].$model.link =
        textFromClipboard;
      this.delayTouch(item);
    },
  },
};
</script>
<style lang="scss" scoped>
.form-input--icon {
  padding: rem(19px 60px);
}

.form {
  &__input-wrapper::v-deep {
    .icon {
      position: absolute;
      left: 1.25rem;
      top: 50%;
      transform: translateY(-50%);
      height: 1.5rem;
      width: 1.5rem;
      border: none;
      margin: 0;
      padding: 0;
      background: transparent;

      svg {
        height: 1.5rem;
        width: 1.5rem;
        fill: $purple;
      }

      &--remove {
        left: unset;
        right: 1.25rem;

        svg {
          fill: $danger;
        }
      }
    }
  }
}

.disabled {
  pointer-events: none;

  button {
    color: lightgray;
  }
}

textarea:disabled,
input:disabled {
  background-color: rgb(236, 236, 236);
  border-color: transparent;
  pointer-events: none;

  &:hover {
    border-color: transparent;
  }
}

button:disabled {
  filter: grayscale(1);
}
</style>
